import { render, staticRenderFns } from "./WsText001.vue?vue&type=template&id=12f710fa"
import script from "./WsText001.vue?vue&type=script&lang=js"
export * from "./WsText001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports